<script setup lang="ts">
import type { CategoriesResponse } from '~/server/api/categories'
import { logger } from './utils/sentry/client-only-logger'
import { getAdditionalErrorData } from './utils/error-handling'
import type { CollectionsDiscoverResponse } from '~/server/api/collections/discover'

useSyncAuth()

const requests = [
  useFetch<CategoriesResponse>(`/api/categories`),
  useFetch<CollectionsDiscoverResponse>(`/api/collections/discover`),
] as const

const [{ data: categories }, { data: discoverCollection }] = await Promise.all(requests)

useCategoriesState(() => categories)
useDiscoverCollectionState(() => discoverCollection)

// onErrorCaptured possibly could be removed
// in favour of our vue:error + app:error hooks, that we have in sentry-client-plugin.
// (overkill, but in MVP we want to be 100% sure errors do not slip)
onErrorCaptured((error) => {
  logger.error(error, {
    additionalData: getAdditionalErrorData({
      errorHandler: 'app.vue: onErrorCaptured',
    }),
  })
})
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
